import { faBriefcase, faDollarSign, faUser, faUserLock } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useEffect, useState } from 'react'
import { Nav, Col, Row, Tab } from 'react-bootstrap';
import { formatToINR, navigateToCrmDetail, putCommaInLeadsValue } from '../../../../../Utils/helpers/commonhelper';
import { toast } from 'sonner';
import useLocalStorageState from 'use-local-storage-state';
import { DeleteRequest, GetRequest } from '../../../../../Utils/hooks/ApiHandler';
import DeleteModal from '../../../../DeleteModal';
import { CreateLead } from '../../../../Leads/CreateLead';
import { CreateDeal } from '../../../../deals/CreateDeal';
import { ProspectsTable } from '../../../../../CommonComponents/ProspectsTable';
import { useGetEssentials } from '../../../../../Utils/hooks/useGetEssentials';
import { useSharedPipelinePermission } from '../../../../../Utils/hooks/usePipelineSharedPermission';
import { useNavigate, useLocation } from 'react-router-dom';

// currentCompanyId = allCompanies[nextPrevious].id
export const CompanyProspectsInfo = ({
    companyData,
    companyId,
    // currentCompanyId,
    contactDetails,
    fetchCompanyDetails
}) => {

    // Session storage and authentication setup
    const { headers, extras, customerId, loginUserId, userType } = useGetEssentials()
    const navigate = useNavigate()
    const location = useLocation()
    // rbac permission object
    const [PERMISSION] = useLocalStorageState('permission')

    // leads and deals permission
    const leadGrant = PERMISSION?.leads;
    const dealGrant = PERMISSION?.deals;
    let idx = 1
    const [loading, setLoading] = useState(false)
    const [statusLoading, setStatusLoading] = useState(false)
    const [showAddDealOffcanvas, setShowAddDealOffcanvas] = useState(false);
    // delete leadId
    const [showLeadDeleteModal, setShowLeadDeleteModal] = useState(false);
    const [associatedDeals, setAssociatedDeals] = useState(false);
    const [showAddLeadsOffcanvas, setShowAddLeadsOffcanvas] = useState(false);
    // stage id for deal set it null
    const [selectedStageId, setSelectedStageId] = useState(null);

    const [currModule, setCurrModule] = useState(null)
    // leads and deals status
    const [dealStatus, setDealStatus] = useState("all");

    const [leadsStatus, setLeadsStatus] = useState("all");

    // set deals card data
    const [dealsCardData, setDealsCardData] = useState([]);

    // deal data set
    const [deals, setDeals] = useState([]);
    // lead and deal id for edit and delete use
    const [editLeadId, setEditLeadId] = useState(null);
    const [leads, setLeads] = useState([]);

    // storing the selectedpipelineid and the stage data to pass on to the details page for stage rendering
    const [selectedPipelineId, setSelectedPipelineId] = useState(null)
    // const [pipelineStages, setPipelineStages] = useState(null)

    // permission for shared users to be passed down to detail page for leads and deals respectively
    // const { permissionAssigned, canEdit } = useSharedPipelinePermission(
    //     selectedPipelineId,
    //     customerId,
    //     loginUserId,
    //     userType,
    //     headers,
    //     extras,
    //     currModule)


    // handlers for leads and deals
    const fetchAllDeals = async () => {
        try {
            setStatusLoading(true);
            const res = await GetRequest(
                `company/fetchAllDealsOfCompany/${companyId}/${customerId}`,
                { headers },
                extras
            );
            if (res.status === 'fail' || res.success === false) {
                setDeals(null)
                return
            }
            setDealsCardData(res.data);
            setDeals(res.data?.deals_list);
        } catch (error) {
            console.error(error);
        } finally {
            setStatusLoading(false);
        }
    };

    const fetchDealsByStatus = async () => {
        try {
            const endpoint =
                dealStatus === "won"
                    ? `/company/fetchAllDealsOfCompanyBasedOnStatus/${companyId}/${customerId}/won`
                    : dealStatus === "lost"
                        ? `/company/fetchAllDealsOfCompanyBasedOnStatus/${companyId}/${customerId}/lost`
                        : dealStatus === "unqualified"
                            ? `/company/fetchAllDealsOfCompanyBasedOnStatus/${companyId}/${customerId}/unqualified`
                            : "";
            setStatusLoading(true);
            const res = await GetRequest(endpoint, { headers }, extras);

            // setDealStatus(res.data)
            setDeals(res?.data);
            // setContactDeals([])
            // setLoading(false)
        } catch (error) {
            console.error(error);
        } finally {
            setStatusLoading(false);
        }
    };

    useEffect(() => {
        if (associatedDeals) {
            fetchDealsByStatus();
        }
    }, [dealStatus, associatedDeals]);


    const fetchLeads_status = async () => {
        if (leadsStatus === 'all') {
            const allContactLeads = companyData[0]?.contact_list?.map(c => c.leads)
            const flattenLeadsArr = allContactLeads?.flat()
            setLeads(flattenLeadsArr || [])
            return;
        }
        try {
            const endpoint =
                leadsStatus === "won"
                    ? `company/fetchWonLeads/${customerId}/${companyId}`
                    : leadsStatus === "lost"
                        ? `company/fetchLostLeads/${customerId}/${companyId}`
                        : leadsStatus === "unqualified"
                            ? `company/fetchUnqualifiedLeads/${customerId}/${companyId}`
                            : "";
            setStatusLoading(true); // Set loading to true when starting
            const res = await GetRequest(endpoint, { headers }, extras);
            const data = res.data && res.data?.map(c => [...c.fetch_leads])
            const finalData = data?.flat()
            setLeads(finalData);
        } catch (err) {
            return
        } finally {
            setStatusLoading(false); // Ensure loading is false even on error
        }
    };

    useEffect(() => {
        if (!associatedDeals) {
            fetchLeads_status();
        }
    }, [leadsStatus, associatedDeals]);


    const handleLeadDetailPage = (val) => {
        setCurrModule("leads")
        navigateToCrmDetail(navigate, location, "/leadDetails", {
            id: val?.id,
            pipeline_id: val?.pipeline_id,
        })
    };

    const handleDealDetailPage = (val) => {
        setCurrModule("deals")
        navigateToCrmDetail(navigate, location, "/dealDetails", {
            id: val?.id,
            pipeline_id: val?.pipeline_id,
        })
    };


    // useEffect(() => {
    //     (async () => {
    //         try {
    //             if (!selectedPipelineId) return
    //             const res = await GetRequest(`lead/fetchPipelineStage/${selectedPipelineId}/${customerId}`, { headers }, extras)
    //             if (res.status === 'fail' || res.success === false) {
    //                 setPipelineStages(null)
    //                 return
    //             }
    //             const pipelineStageData = res.data
    //             const formattedStages = pipelineStageData.map((stage) => ({
    //                 ...stage,
    //                 stage_id: stage.id,
    //                 sequence: String(stage.sequence),
    //                 probability: Math.min(100, stage.probability || 0),
    //                 rotting_days: stage.rotting_days === null ? null : stage.rotting_days,
    //                 rotting_enabled: stage.rotting_days !== null && stage.rotting_days > 0,
    //             }))
    //             setPipelineStages(formattedStages)
    //             setSelectedStageId(formattedStages[0]?.id)
    //         } catch (error) {
    //             return
    //         }
    //     })()
    // }, [selectedPipelineId])

    return (
        <Row
            className="w-100 ms-0 mt-2 ps-0 pe-2"
            style={{ minHeight: "390px" }}
        >
            <Col
                md={12}
                className="tab-container bg-white ps-0 pe-0"
                style={styles.tabContainer}
            >
                <div className="d-flex align-items-center justify-content-between">
                    <div className="d-flex gap-1 align-items-center mx-3">
                        <h4
                            style={{
                                fontSize: associatedDeals ? 15 : 20,
                                fontWeight: 300,
                                color: associatedDeals ? "gray" : "black",
                                cursor: "pointer",
                            }}
                            className="my-3 "
                            onClick={() => {
                                setAssociatedDeals(false);
                            }}
                        >
                            Associated Leads
                        </h4>
                        <span>|</span>
                        <h4
                            style={{
                                fontSize: associatedDeals ? 20 : 15,
                                fontWeight: 300,
                                color: associatedDeals ? "black" : "gray",
                                cursor: "pointer",
                            }}
                            className="my-3 "
                            onClick={() => {
                                setAssociatedDeals(true);
                                fetchAllDeals();
                            }}
                        >
                            Associated Deals
                        </h4>
                    </div>
                    {/* //leads div for add and listing leads */}
                    {!associatedDeals && (
                        <div
                            className="d-flex align-items-center gap-2 pe-3"
                        //  style={{display:associatedDeals ? "none" : "block"}}
                        >
                            <p
                                className="mb-0"
                                style={{
                                    fontSize: 12,
                                    fontWeight: 400,
                                    cursor: "pointer",
                                    color: "#0099ff"
                                }}
                                onClick={() => {
                                    if (!leadGrant?.isCreate) {
                                        toast.warning("You are not authorized for this action!")
                                        return
                                    }
                                    setShowAddLeadsOffcanvas(true);
                                }}
                            >
                                Add Lead
                            </p>
                            <p
                                className="mb-0 mx-2 "
                                style={{
                                    borderRight: "1px solid #c9c9c9",
                                    height: 19,
                                }}
                            ></p>
                            <p
                                className="mb-0"
                                style={{
                                    fontSize: 12,
                                    fontWeight: 400,
                                    cursor: "pointer",
                                    color: "#0099ff"
                                }}
                                onClick={() => {
                                    if (!leadGrant?.isView) {
                                        toast.warning("You are not authorized for this action!")
                                        return
                                    }
                                    window.open(
                                        `${window.location.origin}/leads?module=company&id=${companyId}`,
                                        "_blank"
                                    )
                                }}
                            >
                                List All Leads
                            </p>
                        </div>
                    )}

                    {/* // deals div for add and listing deals */}
                    {associatedDeals && (
                        <div
                            className="d-flex align-items-center gap-2 pe-3"
                        // style={{display:associatedDeals?"block" : "none"}}
                        >
                            <p
                                className="mb-0"
                                style={{
                                    fontSize: 12,
                                    fontWeight: 400,
                                    cursor: "pointer",
                                    color: "#0099ff"
                                }}
                                onClick={() => {
                                    if (!dealGrant?.isCreate) {
                                        toast.warning("You are not authorized for this action!")
                                        return
                                    }
                                    setShowAddDealOffcanvas(true);
                                }}
                            >
                                Add Deal
                            </p>
                            <p
                                className="mb-0 mx-2 "
                                style={{
                                    borderRight: "1px solid #c9c9c9",
                                    height: 19,
                                }}
                            ></p>
                            <p
                                className="mb-0"
                                style={{
                                    fontSize: 12,
                                    fontWeight: 400,
                                    cursor: "pointer",
                                    color: "#0099ff"
                                }}
                                onClick={() => {
                                    if (!dealGrant?.isView) {
                                        toast.warning("You are not authorized for this action!")
                                        return
                                    }
                                    window.open(
                                        `${window.location.origin}/deals?module=company&id=${companyId}`,
                                        "_blank"
                                    )
                                }}
                            >
                                List All Deals
                            </p>
                        </div>
                    )}
                </div>

                {associatedDeals ? (
                    // deals tab container
                    <Tab.Container >
                        <Nav
                            variant="pills"
                            className="nav-style-1 mb-0 d-flex flex-nowrap newNavTab associatedDeals gap-1 mx-0"
                        >
                            <Nav.Item
                                className="me-0"
                                style={{ minWidth: "17%" }}
                                onClick={() => {
                                    // setLeads([]);
                                    setDealStatus("all");
                                    fetchAllDeals();
                                }}
                            >
                                <Nav.Link
                                    eventKey="Communications"
                                    style={styles.navLinksStyle}
                                >
                                    <p className="d-flex justify-content-between mb-1 text-white">
                                        All Deals{" "}
                                        <FontAwesomeIcon icon={faDollarSign} />
                                    </p>
                                    <p
                                        className="mb-0 mt-2 d-flex justify-content-between text-white"
                                        style={{ fontSize: "25px", fontWeight: 300 }}
                                    >
                                        {putCommaInLeadsValue(
                                            dealsCardData?.allDeals || 0
                                        )}
                                        <span
                                            style={{
                                                fontSize: "12px",
                                                fontWeight: 400,
                                                textAlign: "end",
                                            }}
                                        >
                                            <p
                                                className="mb-0"
                                                style={{
                                                    fontWeight: 200,
                                                    fontSize: 10,
                                                    color: "white",
                                                }}
                                            >
                                                Approx Value INR
                                            </p>
                                            <span className="text-white">
                                                {formatToINR(
                                                    dealsCardData?.total_revenue || "0"
                                                )}
                                            </span>
                                        </span>
                                    </p>
                                </Nav.Link>
                            </Nav.Item>
                            <Nav.Item
                                className="me-0"
                                style={{
                                    minWidth: "17%",
                                    cursor:
                                        dealsCardData?.won === 0
                                            ? "not-allowed"
                                            : "pointer",
                                }}
                                onClick={() => {
                                    if (dealsCardData?.won === 0) {
                                        return;
                                    } else {
                                        // setContactDeals([]);
                                        setDealStatus("won");
                                        fetchDealsByStatus();
                                    }
                                }}
                            >
                                <Nav.Link
                                    eventKey="Locations"
                                    style={styles.inActiveNavLinksStyle}
                                >
                                    <p className="d-flex justify-content-between mb-1 text-white">
                                        Won Deals{" "}
                                        <FontAwesomeIcon icon={faBriefcase} />
                                    </p>
                                    <p
                                        className="mb-0 mt-2 d-flex justify-content-between text-white"
                                        style={{ fontSize: "25px", fontWeight: 300 }}
                                    >
                                        {putCommaInLeadsValue(
                                            dealsCardData?.won || 0
                                        )}
                                        <span
                                            style={{
                                                fontSize: "12px",
                                                fontWeight: 400,
                                                textAlign: "end",
                                            }}
                                        >
                                            <p
                                                className="mb-0"
                                                style={{
                                                    fontWeight: 200,
                                                    fontSize: 10,
                                                    color: "white",
                                                }}
                                            >
                                                Approx Value INR
                                            </p>
                                            <span className="text-white">
                                                {formatToINR(
                                                    dealsCardData?.won_revenue || "0"
                                                )}
                                            </span>
                                        </span>
                                    </p>
                                </Nav.Link>
                            </Nav.Item>
                            <Nav.Item
                                className="me-0"
                                style={{
                                    minWidth: "17%",
                                    cursor:
                                        dealsCardData?.lost === 0
                                            ? "not-allowed"
                                            : "pointer",
                                }}
                                onClick={() => {
                                    if (dealsCardData?.lost === 0) {
                                        return;
                                    } else {
                                        // setContactDeals([]);
                                        setDealStatus("lost");
                                        fetchDealsByStatus();
                                    }
                                }}
                            >
                                <Nav.Link
                                    eventKey="Socials"
                                    style={styles.inActiveNavLinksStyle}
                                >
                                    <p className="d-flex justify-content-between mb-1 text-white">
                                        Lost Deals <FontAwesomeIcon icon={faUser} />
                                    </p>
                                    <p
                                        className="mb-0 mt-2 d-flex justify-content-between text-white"
                                        style={{ fontSize: "25px", fontWeight: 300 }}
                                    >
                                        {putCommaInLeadsValue(
                                            dealsCardData?.lost || 0
                                        )}
                                        <span
                                            style={{
                                                fontSize: "12px",
                                                fontWeight: 400,
                                                textAlign: "end",
                                            }}
                                        >
                                            <p
                                                className="mb-0"
                                                style={{
                                                    fontWeight: 200,
                                                    fontSize: 10,
                                                    color: "white",
                                                }}
                                            >
                                                Approx Value INR
                                            </p>
                                            <span className="text-white">
                                                {formatToINR(
                                                    dealsCardData?.lost_revenue || "0"
                                                )}
                                            </span>
                                        </span>
                                    </p>
                                </Nav.Link>
                            </Nav.Item>
                            <Nav.Item
                                className="me-0"
                                style={{
                                    minWidth: "17%",
                                    cursor:
                                        dealsCardData?.unqualified === 0
                                            ? "not-allowed"
                                            : "pointer",
                                }}
                                onClick={() => {
                                    if (dealsCardData?.unqualified === 0) {
                                        return;
                                    } else {
                                        // setContactDeals([]);
                                        setDealStatus("unqualified");
                                        fetchDealsByStatus();
                                    }
                                }}
                            >
                                <Nav.Link
                                    eventKey="Socials"
                                    style={styles.inActiveNavLinksStyle}
                                >
                                    <p className="d-flex justify-content-between mb-1 text-white">
                                        Unqualified Deals{" "}
                                        <FontAwesomeIcon icon={faUserLock} />
                                    </p>
                                    <p
                                        className="mb-0 mt-2 d-flex justify-content-between text-white"
                                        style={{ fontSize: "25px", fontWeight: 300 }}
                                    >
                                        {putCommaInLeadsValue(
                                            dealsCardData?.unqualified || 0
                                        )}
                                        <span
                                            style={{
                                                fontSize: "12px",
                                                fontWeight: 400,
                                                textAlign: "end",
                                            }}
                                        >
                                            <p
                                                className="mb-0"
                                                style={{
                                                    fontWeight: 200,
                                                    fontSize: 10,
                                                    color: "white",
                                                }}
                                            >
                                                Approx Value INR
                                            </p>
                                            <span className="text-white">
                                                {formatToINR(
                                                    dealsCardData?.unqualified_revenue ||
                                                    "0"
                                                )}
                                            </span>
                                        </span>
                                    </p>
                                </Nav.Link>
                            </Nav.Item>
                        </Nav>
                        <ProspectsTable
                            type={"deals"}
                            data={deals}
                            permissionGrant={dealGrant}
                            currentNavCard={dealStatus}
                            openDetailPage={handleDealDetailPage}
                            setSelectedPipelineId={setSelectedPipelineId}
                            isLoading={statusLoading}
                        />

                    </Tab.Container>
                ) : (
                    // leads tab container
                    <Tab.Container >
                        <Nav
                            variant="pills"
                            className="nav-style-1 mb-0 d-flex flex-nowrap newNavTab associatedDeals gap-1 mx-0"
                        >
                            <Nav.Item
                                className="me-0"
                                style={{ minWidth: "17%" }}
                                onClick={() => {
                                    setLeadsStatus("all");
                                }}
                            >
                                <Nav.Link
                                    eventKey="Communications"
                                    style={styles.navLinksStyle}
                                >
                                    <p className="d-flex justify-content-between mb-1 text-white">
                                        All Leads{" "}
                                        <FontAwesomeIcon icon={faDollarSign} />
                                    </p>
                                    <p
                                        className="mb-0 mt-2 d-flex justify-content-between text-white "
                                        style={{
                                            fontSize: "25px",
                                            fontWeight: 300,
                                        }}
                                    >
                                        {putCommaInLeadsValue(
                                            contactDetails?.total_leads || 0
                                        )}
                                        <span
                                            style={{
                                                fontSize: "12px",
                                                fontWeight: 400,
                                                textAlign: "end",
                                                color: "white",
                                            }}
                                        >
                                            <p
                                                className="mb-0 text-white  "
                                                style={{
                                                    fontWeight: 200,
                                                    fontSize: 10,
                                                    color: "white",
                                                }}
                                            >
                                                Approx Value INR
                                            </p>
                                            <span className="text-white">
                                                {formatToINR(
                                                    contactDetails?.total_revenue || "0"
                                                )}
                                            </span>
                                        </span>
                                    </p>
                                </Nav.Link>
                            </Nav.Item>
                            <Nav.Item
                                className="me-0"
                                style={{
                                    minWidth: "17%",
                                    cursor:
                                        contactDetails?.won_leads?.[0]
                                            .total_won_leads === 0
                                            ? "not-allowed"
                                            : "pointer",
                                }}
                                onClick={() => {
                                    if (
                                        contactDetails?.won_leads?.[0]
                                            .total_won_leads === 0
                                    ) {
                                        return;
                                    } else {
                                        setLeadsStatus("won");
                                    }
                                }}
                            >
                                <Nav.Link
                                    eventKey="Locations"
                                    style={styles.inActiveNavLinksStyle}
                                >
                                    <p className="d-flex justify-content-between mb-1 text-white ">
                                        Won Leads{" "}
                                        <FontAwesomeIcon icon={faBriefcase} />
                                    </p>
                                    <p
                                        className="mb-0 mt-2 d-flex justify-content-between text-white "
                                        style={{
                                            fontSize: "25px",
                                            fontWeight: 300,
                                        }}
                                    >
                                        {putCommaInLeadsValue(
                                            contactDetails?.won || 0
                                        )}
                                        <span
                                            style={{
                                                fontSize: "12px",
                                                fontWeight: 400,
                                                textAlign: "end",
                                            }}
                                        >
                                            <p
                                                className="mb-0"
                                                style={{
                                                    fontWeight: 200,
                                                    fontSize: 10,
                                                    color: "white",
                                                }}
                                            >
                                                Approx Value INR
                                            </p>
                                            <span className="text-white">
                                                {formatToINR(
                                                    contactDetails?.total_revenue_won || "0"
                                                )}
                                            </span>
                                        </span>
                                    </p>
                                </Nav.Link>
                            </Nav.Item>
                            <Nav.Item
                                className="me-0"
                                style={{
                                    minWidth: "17%",
                                    cursor:
                                        contactDetails?.lost_leads?.[0]
                                            .total_lost_leads === 0
                                            ? "not-allowed"
                                            : "pointer",
                                }}
                                onClick={() => {
                                    if (
                                        contactDetails?.lost_leads?.[0]
                                            .total_lost_leads === 0
                                    ) {
                                        return;
                                    } else {
                                        setLeadsStatus("lost");
                                    }
                                }}
                            >
                                <Nav.Link
                                    eventKey="Socials"
                                    style={styles.inActiveNavLinksStyle}
                                >
                                    <p className="d-flex justify-content-between mb-1 text-white">
                                        Lost Leads <FontAwesomeIcon icon={faUser} />
                                    </p>
                                    <p
                                        className="mb-0 mt-2 d-flex justify-content-between text-white"
                                        style={{
                                            fontSize: "25px",
                                            fontWeight: 300,
                                        }}
                                    >
                                        {putCommaInLeadsValue(
                                            contactDetails?.lost || 0
                                        )}
                                        <span
                                            style={{
                                                fontSize: "12px",
                                                fontWeight: 400,
                                                textAlign: "end",
                                            }}
                                        >
                                            <p
                                                className="mb-0"
                                                style={{
                                                    fontWeight: 200,
                                                    fontSize: 10,
                                                    color: "white",
                                                }}
                                            >
                                                Approx Value INR
                                            </p>
                                            <span className="text-white">
                                                {formatToINR(
                                                    contactDetails?.total_revenue_lost ||
                                                    "0"
                                                )}
                                            </span>
                                        </span>
                                    </p>
                                </Nav.Link>
                            </Nav.Item>
                            <Nav.Item
                                className="me-0"
                                style={{
                                    minWidth: "17%",
                                    cursor:
                                        contactDetails?.unqualified_leads?.[0]
                                            .total_unqualified_leads === 0
                                            ? "not-allowed"
                                            : "pointer",
                                }}
                                onClick={() => {
                                    if (
                                        contactDetails?.unqualified_leads?.[0]
                                            .total_unqualified_leads === 0
                                    ) {
                                        return;
                                    } else {
                                        setLeadsStatus("unqualified");
                                    }
                                }}
                            >
                                <Nav.Link
                                    eventKey="Socials"
                                    style={styles.inActiveNavLinksStyle}
                                >
                                    <p className="d-flex justify-content-between mb-1 text-white">
                                        Unqualified Leads{" "}
                                        <FontAwesomeIcon icon={faUserLock} />
                                    </p>
                                    <p
                                        className="mb-0 mt-2 d-flex justify-content-between text-white"
                                        style={{
                                            fontSize: "25px",
                                            fontWeight: 300,
                                        }}
                                    >
                                        {putCommaInLeadsValue(
                                            contactDetails?.unqualified || 0
                                        )}
                                        <span
                                            style={{
                                                fontSize: "12px",
                                                fontWeight: 400,
                                                textAlign: "end",
                                            }}
                                        >
                                            <p
                                                className="mb-0"
                                                style={{
                                                    fontWeight: 200,
                                                    fontSize: 10,
                                                    color: "white",
                                                }}
                                            >
                                                Approx Value INR
                                            </p>
                                            <span className="text-white">
                                                {formatToINR(
                                                    contactDetails?.total_revenue_unqualified ||
                                                    "0"
                                                )}
                                            </span>
                                        </span>
                                    </p>
                                </Nav.Link>
                            </Nav.Item>
                        </Nav>
                        <ProspectsTable
                            type={"leads"}
                            data={leads}
                            permissionGrant={leadGrant}
                            currentNavCard={leadsStatus}
                            openDetailPage={handleLeadDetailPage}
                            setSelectedPipelineId={setSelectedPipelineId}
                            isLoading={statusLoading}
                        />

                    </Tab.Container>
                )}
            </Col>

            {
                showAddDealOffcanvas && (
                    <CreateDeal
                        show={showAddDealOffcanvas}
                        onHide={() => {
                            setShowAddDealOffcanvas(false);
                        }}
                        moduleName="company"
                        refetchDeals={fetchAllDeals}
                        contactArrCompany={companyData[0].contact_list}
                    />
                )
            }
            {
                showAddLeadsOffcanvas && (
                    <CreateLead
                        show={showAddLeadsOffcanvas}
                        onHide={() => {
                            setShowAddLeadsOffcanvas(false);
                            setEditLeadId(null);
                        }}
                        refetchLeads={fetchCompanyDetails}
                        module_name="company"
                        contactArray={companyData[0].contact_list}
                        id={companyId}
                        editId={editLeadId}
                    />
                )
            }
        </Row >
    )
}

const styles = {
    navLinksStyle: {
        borderRadius: "0px",
        borderBottom: "1px solid #E0E4F8",
        borderRight: "1px solid #E0E4F8",
        fontSize: 14,
        padding: "11px",
        fontFamily: '"Inter", sans-serif !important',
        fontWeight: 400,
        lineHeight: 1.5,
    },
    inActiveNavLinksStyle: {
        borderRadius: "0px",
        borderBottom: "1px solid #E0E4F8",
        borderRight: "1px solid #E0E4F8",
        fontSize: 14,
        padding: "11px",
        fontFamily: '"Inter", sans-serif !important',
        fontWeight: 400,
        lineHeight: 1.5,
        pointerEvents: "none",
    },

    tabContainer: {
        border: "1px solid #E0E4F8",
        borderRadius: "4px",
    },
    lastdStyle: {
        padding: "0 !important",
    },
    lastactiontd: {
        padding: "0px !important",
    },

};